import React, { useContext } from 'react';
import { Text } from 'components/typography/Text';
import { Image } from 'semantic-ui-react';
import userSrc from 'assets/media/user.png';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
// eslint-disable-next-line import/no-cycle
import { UserAdministrationModalContext } from '../../../../../../index';
import styles from './styles.module.scss';

export const UserItem = ({ user }) => {

  const { selectedUser, setSelectedUser, setIsAddingUser } = useContext(
    UserAdministrationModalContext,
  );

  const onUserClick = () => {
    setSelectedUser(user);
    setIsAddingUser(false);
  };

  return (
    <div
      className={styles.userCard}
      onClick={onUserClick}
    >
      <div className={styles.details}>
        <Image
          className={styles.img}
          id="user-avatar"
          alt="user-avatar"
          src={userSrc}
          size="tiny"
          circular
        />

        <Text
          size={14}
          uppercase
        >
          {user.firstName} {user.lastName}
        </Text>
      </div>

      <ShouldRender condition={selectedUser && selectedUser.id === user.id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
